import { HOST_TOOL_NAMES } from "../../turns/turn-constants";

export const SOFT_FAIL_CAPTURE_TOOLS = new Set<string>([
  HOST_TOOL_NAMES.TAKE_SCREENSHOT,
  HOST_TOOL_NAMES.RECORD_VIDEO,
  HOST_TOOL_NAMES.ATTACH_IMAGE,
  HOST_TOOL_NAMES.ATTACH_FILE,
  HOST_TOOL_NAMES.GENERATE_IMAGE,
  HOST_TOOL_NAMES.ANNOTATE_IMAGE,
]);
